import whalesApi from "@/services/api/whales";

const state = {
  whale: {},
  mode: "quick",
  isDialogOpen: false,
  sightings: [],
  images: [],
  isLoading: false,
  lineage: [],
  lineageLoading: false,
};

const getters = {
  whale: (state) => state.whale,
  mode: (state) => state.mode,
  dialog: (state) => state.isDialogOpen,
  sightings: (state) => state.sightings,
  images: (state) => state.images,
  loading: (state) => state.isLoading,
  lineage: (state) => state.lineage,
  lineageLoading: (state) => state.lineageLoading,
};

const actions = {
  openQuick({ commit }, { whale }) {
    commit("open", { whale, mode: "quick" });
  },
  async openRich({ commit }, { whale }) {
    commit("open", { whale, mode: "rich" });
    commit("loading", true);
    const [sightingsResult, imagesResult] = await Promise.all([
      whalesApi.sightingsForWhale(whale.whaleId),
      whalesApi.imagesForWhale(whale.whaleId),
    ]);
    commit("loaded", {
      sightings: sightingsResult.data,
      images: imagesResult.data,
    });
    commit("loading", false);
  },
  async openByWhaleId({ dispatch }, { whaleId, mode }) {
    const result = await whalesApi.getByWhaleId(whaleId);
    const whale = result.data;
    if (whale) {
      if (mode === "rich") {
        dispatch("openRich", { whale });
      } else {
        dispatch("openQuick", { whale });
      }
    }
  },
  close({ commit }) {
    commit("close");
  },
  async setFeaturePhoto({ commit, state }, imageId) {
    const result = await whalesApi.setFeaturePhoto(state.whale.id, imageId);
    if (result) {
      commit("featurePhotoUpdated", result.data);
    }
  },
  async loadLineage({ commit }, matriline) {
    commit("lineageLoading", true);
    const result = await whalesApi.byMatriline(matriline);
    commit("setLineage", result.data);
    commit("lineageLoading", false);
  },
};

const mutations = {
  open(state, { whale, mode }) {
    state.whale = { ...whale };
    state.mode = mode;
    state.isDialogOpen = true;
    state.sightings = [];
    state.images = [];
    state.lineage = [];
  },
  close(state) {
    state.isDialogOpen = false;
    state.whale = {};
    state.sightings = [];
    state.images = [];
    state.lineage = [];
  },
  loading(state, isLoading) {
    state.isLoading = isLoading;
  },
  loaded(state, { sightings, images }) {
    state.sightings = sightings;
    state.images = images;
  },
  featurePhotoUpdated(state, whale) {
    state.whale = { ...whale };
  },
  setLineage(state, lineage) {
    state.lineage = lineage;
  },
  lineageLoading(state, isLoading) {
    state.lineageLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
